import { render, staticRenderFns } from "./online-permission.vue?vue&type=template&id=128177e0&scoped=true"
import script from "./online-permission.vue?vue&type=script&lang=js"
export * from "./online-permission.vue?vue&type=script&lang=js"
import style0 from "./online-permission.vue?vue&type=style&index=0&id=128177e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128177e0",
  null
  
)

export default component.exports